
import { useEffect, useRef, useState } from 'react'
import {
  Table,
  Container,
  Row,
  Col,
  Card,
  Image,
  Button,
} from 'react-bootstrap'
import { FaEdit, FaPrint, FaSyncAlt } from 'react-icons/fa'
import { FaDownload } from 'react-icons/fa'
import Cookies from 'js-cookie'

import Form from 'react-bootstrap/Form'
import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'
import axios from 'axios'
import { Typeahead } from 'react-bootstrap-typeahead'
import { useNavigate, useParams } from 'react-router-dom'
import html2pdf from 'html2pdf.js';
import { useAuth } from './AuthContext'

export default function ExamMarksheet() {
  const {token} = useAuth()
  const institute_id = Cookies.get('institute_id')
  
  const [instituteName, setInstitutename] = useState()
  const [institues, setInstitutes] = useState([])
  const [instituteAddress, setInstituteAddress] = useState()
  const [institutePincode, setInstitutePincode] = useState()
  const [instituteId, setInstituteId] = useState()

  useEffect(() => {
    const storedInstitute = Cookies.get('institute_name')
    const storedInstituteId = Cookies.get('institute_id')
    console.log('storedInstituteId', storedInstituteId)
    if (storedInstituteId) setInstituteId(storedInstituteId)

    if (storedInstitute) setInstitutename(storedInstitute)

    ApiEndpoints.getAllInstitutes().then((res) => {
      console.log('List of Institutes: ', res.data.data)
      const instituteData = res.data.data
      setInstitutes(instituteData)
      if (storedInstituteId) {
        const matchedInstitute = instituteData.find(
          (inst) => String(inst.institute_id) === String(storedInstituteId),
        )
        console.log('matchedInstitute', matchedInstitute)
        setInstituteAddress(matchedInstitute?.address)
        setInstitutePincode(matchedInstitute.pincode)
      }
    })
  }, [])

  const [showMarksheet, setShowMarksheet] = useState(false)


  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { student_id, course_id, class_id } = useParams()
  console.log(
    student_id,
    course_id,
    class_id,
    'Type of Class Id: ',
    typeof class_id,
  )
  const [processedSubjects, setProcessedSubjects] = useState([]);
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [students, setStudents] = useState([])
  const [selectedCourse, setSelectedCourse] = useState()
  const [selectedClass, setSelectedClass] = useState()
  // const[selectedExamId,setSelectedExamId]=useState("")
  const [selectedStudent, setSelectedStudent] = useState()
  const [selectedStudentName, setSelectedStudentName] = useState('')
  const [data, setData] = useState([])
  const [img, setImg]=useState(null)

  const navigate = useNavigate()
  const componentRef = useRef()
  
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  const fetchData = async () => {
    try {
      const res = await ApiEndpoints.getStudentExamMarks(
        selectedStudent,
        Number(selectedCourse),
      )
      console.log('Images see from this data:', res.data.data)
      setData(res.data.data)
      setImg(res.data.data[0]?.student)
      const response = res.data.data
      const processedSubjects = processSubjectData(response)
      setProcessedSubjects(processedSubjects)

    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }
  useEffect(() => {
    if (selectedStudent && selectedCourse) {
      fetchData()
    }
  }, [selectedStudent, selectedCourse])

  useEffect(() => {
    if (course_id && courses.length > 0) {
      setSelectedCourse(course_id)
      console.log(
        'Courses: ',
        courses,
        ' course_id: ',
        course_id,
        ' -> within useEffect',
      )
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id, courses])

  useEffect(() => {
    if (class_id && classes.length > 0) {
      console.log(
        'Classes: ',
        courses,
        ' class_id: ',
        course_id,
        ' -> within useEffect',
      )
      setSelectedClass(Number(class_id))
    }
    handleClassChange({ target: { value: class_id } })
  }, [class_id, classes])

  useEffect(() => {
    if (student_id && students.length > 0) {
      console.log(
        'Students: ',
        students,
        ' student_id: ',
        course_id,
        ' -> within useEffect',
      )
      const matchedStudent = students.find((st) => st.id === Number(student_id))
      console.log('matchedStudent', matchedStudent)
      if (matchedStudent) {
        setSelectedStudent(Number(student_id))
        handleStudentChange({ target: { value: student_id } })
      }
    }
  }, [student_id, students])

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('selected course id:', courseId)
    setSelectedCourse(courseId)
    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId).then((res) => {
        console.log('Classes after course:', res.data.data)
        setClasses(res.data.data)
      })
    }
  }

  const handleClassChange = (e) => {
    const classId = e.target.value
    console.log(
      'Selected class id',
      classId,
      'Type of Selected Class Id:',
      typeof classId,
    )
    setSelectedClass(classId)
    if (classId) {
       const institueId = Cookies.get('institute_id')
            const headers = {
              institute_id: institueId || institute_id,
              Authorization: `Bearer ${token}`
            }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class:', res.data.data)
          setStudents(res.data.data)
        })
    }
  }

  const handleStudentChange = (e) => {
    const studentId = e.target.value
    console.log('Selected Student:', studentId)
    setSelectedStudent(studentId)
    const studentName = students.find((st) => st.id === Number(studentId))?.name
    console.log('studentName:', studentName)
    setSelectedStudentName(studentName)
    if (studentId) {
      setShowMarksheet(true)
      // fetchData()
    }
  }

  console.log(
    'Filtered selected class:',
    classes.filter((cs) => cs.id === Number(class_id)),
  )

  const handleStudentMarksheet = () => {
    setShowMarksheet(true)
  }

  const handleEditMarksheet = (examId) => {
    const filteredData = data.filter((entry) => entry.exam_id === examId)

    navigate(
      `/AddExamResult/${selectedStudent}/${selectedCourse}/${selectedClass}`,
      { state:{
        data:filteredData,
        selectedExamId:examId
      }}
    )
    console.log("Data from examarksheet to addexamresult:", data)
  }
  const handleRefresh = () => {
    setSelectedCourse(null)
    setSelectedClass(null)
    setSelectedStudent(null)
    setSelectedStudentName(Number(student_id))
    setShowMarksheet(false)
  }
  console.log('Student Id:', selectedStudent)
  console.log('Course Id:', selectedCourse)
  console.log('Class Id:', selectedClass)


  const examNames = [...new Set(data.map(item => item.exam?.exam_name))]

   // 2. Get unique subjects and group their exam marks
  //  const subjectMap = {}

  //  data.forEach(item => {
  //    const subjectName = item.subject?.subject_name || 'N/A'
  //    const examName = item.exam?.exam_name
  //    const marks = item.marks
  //    const status = item.status
 
  //    if (!subjectMap[subjectName]) {
  //      subjectMap[subjectName] = {
  //        exams: {},
  //        status,
  //      }
  //    }
 
  //    subjectMap[subjectName].exams[examName] = marks
  //  })
 
  //  const subjects = Object.entries(subjectMap)
 

  const processSubjectData = (data) => {
    const subjectMap = {};
  
    data.forEach((entry) => {
      const subjectName = entry.subject.subject_name;
      const examName = entry.exam.exam_name;
      const marks = parseFloat(entry.marks);
      const status = entry.status;
      const totalMarks = entry.exam.total_marks;
  
      if (!subjectMap[subjectName]) {
        subjectMap[subjectName] = {
          subjectName,
          exams: {},
          total: 0,
          count: 0,
          statusList: [],
          maxTotalMarks: 0,
        };
      }
  
      subjectMap[subjectName].exams[examName] = {
        marks,
        totalMarks,
      };
  
      subjectMap[subjectName].total += marks;
      subjectMap[subjectName].count += 1;
      subjectMap[subjectName].statusList.push(status);
      subjectMap[subjectName].maxTotalMarks = totalMarks; // assuming same across
    });
  
    // Now map into array
    return Object.values(subjectMap).map((subject) => {
      const average = (subject.total / subject.count).toFixed(2);
      const finalStatus = subject.statusList.includes("fail") ? "Fail" : "Pass";
  
      return {
        subjectName: subject.subjectName,
        exams: subject.exams,
        average,
        finalStatus,
      };
    });
  };
  

  
// Before rendering table, define:
const uniqueExams = Array.from(
  new Map(
    data.map((item) => [item.exam_id, item.exam.exam_name,])
  ).entries()
)
const examTotalMarksMap = new Map()
data.forEach((item)=>{
  examTotalMarksMap.set(item.exam.exam_name, item.exam.total_marks)
})



const handleDownload = () => {
  const element = document.getElementById('print_page');
  if (!element) return;

  // Add print styles temporarily
  element.classList.add('pdf-style');

  const opt = {
    margin:       0,
    filename:     `${selectedStudentName || 'student'}_marksheet.pdf`,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  { scale: 2, useCORS: true },
    jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  html2pdf().set(opt).from(element).save().finally(() => {
    element.classList.remove('pdf-style');
  });
};
  const handlePrint = () => {
    const element = document.getElementById('print_page');
    if (!element) return;
    element.classList.add('pdf-style');
    setTimeout(() => {
      window.print();
      element.classList.remove('pdf-style');
    }, 200);
  };

  

  return (
    <>
    <style>

{
  `
  /* Only add watermark inside the marksheet card */
.print-card {
  position: relative; /* Enable positioning for watermark inside */
  background-color: white;
  overflow: hidden;
}

/* Watermark image inside the card */
.print-card .watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
  z-index: 0;
  width: 100%; /* Adjust as needed */
  pointer-events: none;
}

.print-card .watermark-logo {
  width: 100%;
  height: auto;
  object-fit: contain;
   filter: brightness(0.9) contrast(1.4);
}

/* Content stays above the watermark */
.print-card *:not(.watermark-logo-wrapper):not(.watermark-logo) {
  position: relative;
  z-index: 1;
}

  
   @media print {
        body, html {
          margin: 0 !important;
          padding: 0 !important;
          font-size: 18px !important; /* Adjust overall print font size */
          overflow: hidden !important;
          margin-top: .7rem !important;
        }

        * {
          font-size: inherit !important; /* Inherit global font-size */
        }

        .print-card {
          width: 130% !important;
          left: -59% !important;
          font-size: 15px !important;
          // page-break-inside: avoid !important;

        }
        .no-print, .print-buttons {
          display: none !important;
        }

        .profile-print {
          display: flex !important;
          flex-direction: row !important;
          justify-content: space-between !important;
          align-items: center !important;
            flex-wrap: nowrap !important;
          gap: 0 !important;
          margin-top: -.8rem !important;
          margin-bottom: -0.2rem !important;

              line-height: -3 !important;

        }

        .profile-print .col-md-9,
        .profile-print > .col-md-8 {
          width: 75% !important;
          flex: 0 0 75% !important;
          max-width: 75% !important;
        }

        .profile-print .col-md-3,
        .profile-print > .col-md-3 {
          width: 25% !important;
          flex: 0 0 25% !important;
          max-width: 25% !important;
          text-align: center !important;
          align-self: flex-start !important;
        }

        .profile-print .col-md-8 .row {
          display: flex !important;
          flex-direction: row !important;
        }

        .profile-print .col-md-8 .col-md-6 {
          width: 50% !important;
          flex: 0 0 50% !important;
          max-width: 50% !important;
        }

        .profile-print img {
          width: 130px !important;
          height: 130px !important;
          object-fit: cover !important;
          border: .5px solid #333 !important;
          display: block;
          margin: auto;
        }

        .table-head-print th {
          // background-color: black !important;
          color: dark !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          font-size: 18px !important;
        }

        .table-body-print td,
        .table-footer-print {
          font-size: 18px !important;
        }
}



  /* Optional: hide edit buttons in print */
  .pdf-style .table-head-print th button {
    display: none !important;
  }



   @media print {
  .print-card .institute-header-text h2, h4{
    font-size: 16px !important;
  }
.print-logo {
      width: 70px !important;
      height: 70px !important;
    } 

    
.nielit-logo {
      width: 80px !important;
      height: 80px !important;
      margin-top:3rem !important;
    } 
      
    .img-nct{
width: 50px !important;
      height: 50px !important;
          }
}


     @media print {
  .print-card .sub-header  h4 {
    font-size: 16px !important;
    margin-top: -.5rem !important;

  }
   

  .print-card .sub-header  h5 {
        margin-top: -.5rem !important;
    //  margin-bottom: -1rem !important;

  }
     .print-card .sub-header  p {
        margin-top: -.5rem !important;
     margin-bottom: -.8rem !important;

  }
}

/* Remove background from table to allow watermark visibility */
.print-card table,
.print-card th,
.print-card td {
  background-color: transparent !important;
  z-index: 1 !important;
}

@media print {
  .print-card .watermark-logo-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    opacity: 1 !important;
  }

  .print-card .watermark-logo {
    width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
  }
}

.pdf-style thead,
{
 width: auto !important;
 max-width: 100% !important;
 word-wrap: break-word !important;
}

.pdf-style thead {
 display: table-header-group !important;
}

.pdf-style thead th {
 white-space: normal !important;
 font-size: 11px !important;
 padding: 6px 4px !important;
}

.pdf-style .table-head-print th {
 width: auto !important;
 text-align: center !important;
}
 @media print {
  .print-card .table-footer-print {
          margin-top: 3.3rem !important;
          margin-bottom: -2.5rem !important;
}

}
 @media print {
 .print-card .powered-by-footer {
           margin-top: -.7rem !important;
}

  .print-card .powered-by-footer .powered{
          margin-top: 1rem !important;
          // border-top: none !important;
}
}



        .table-body-print td,
        .table-footer-print {
          font-size: 18px !important;
        }
   .pdf-style {
   font-size: 11px !important;
    padding: 5mm 8mm;
  }

  .pdf-style * {
  font-size: 11px !important; /* Consistent small font */
  line-height: 1.4 !important;
}

.pdf-style h1 {
  font-size: 18px !important;
}
.pdf-style h4, .pdf-style h5 {
  font-size: 14px !important;
}
.pdf-style p, .pdf-style td, .pdf-style th, .pdf-style small {
  font-size: 11px !important;
}
.pdf-style .no-print{
  display: none !important;
}
.pdf-style .card {
  border: none !important;
  box-shadow: none !important;
}

.pdf-style .sub-header h4,
.pdf-style .sub-header h5,
.pdf-style .sub-header p {
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
}
  
.pdf-style .watermark-logo-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1;
  z-index: 0;
  width: 60%;
  pointer-events: none;
}

.pdf-style .marksheet-content {
  position: relative;
  z-index: 1;
}
  .pdf-style .watermark-logo-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    opacity: 1 !important;
  }

  .pdf-style .watermark-logo {
    width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
  }


}


`
}
</style>

      <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white no-print">
          <h2 className="m-0">
            View{' '}
            <span className="text-warning">
              {selectedStudentName ? `${selectedStudentName}'s` : ''}
            </span>{' '}
            Marksheet
          </h2>
        </div>
      </div>

      <Row className="align-items-end g-3 mt-3 no-print">
        <Col md={3}>
          <Form.Group className="text-start fw-bold">
            <Form.Label>Select Course</Form.Label>

            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({
                    target: { value: course.id },
                  })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedCourse),
              )}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold">
            <Form.Label>Select Class</Form.Label>

            <Typeahead
              id="class-select"
              labelKey="class_name"
              onChange={(selected) => {
                const cls = selected[0]
                if (cls) {
                  handleClassChange({ target: { value: cls.id } })
                } else {
                  handleClassChange({ target: { value: '' } })
                }
              }}
              options={classes}
              placeholder="Select Class"
              selected={classes.filter((cs) => cs.id === Number(selectedClass))}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="text-start fw-bold">
            <Form.Label>Select Student</Form.Label>

            <Typeahead
              id="student-select"
              labelKey="name"
              onChange={(selected) => {
                const st = selected[0]
                if (st) {
                  handleStudentChange({ target: { value: st.id } })
                } else {
                  handleStudentChange({ target: { value: '' } })
                }
              }}
              onClick={handleStudentMarksheet}
              options={students}
              placeholder="Select Student"
              // selected={students.filter(
              //   (st) => st.id === selectedStudent || Number(student_id),
              // )}
              selected={
                selectedStudent
                  ? students.filter(
                      (st) => Number(st.id) === Number(selectedStudent),
                    )
                  : []
              }
            />
          </Form.Group>
        </Col>

        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="mt-3"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>

      </Row>
     {data && selectedStudent && showMarksheet && (
       <Row className='no-print'>
       <div className="mt-4 justify-content-end d-flex">
             <Button onClick={handlePrint} variant="success" className="shadow-lg fw-bold no-print">
               <FaPrint /> Print Marksheet
             </Button>
 
             <Button onClick={handleDownload} variant="primary" className="shadow-lg fw-bold ms-5 no-print">
               <FaDownload /> Download Marksheet
             </Button>
           </div>
       </Row>
     )}
     
      {data && selectedStudent && showMarksheet ? (
        
        <div 
        id="print_page"
          // ref={componentRef}
          // className="mt-4 w-100 position-relative watermark-container"
          className="mt-4 position-relative watermark-container"
          style={{ display: showMarksheet ? 'block' : 'none' }}>
           
          
           
          <div className="watermark-content">
        
              <Card className="p-4 shadow-sm border-dark rounded-2 print-card">
              <div className="watermark-logo-wrapper">
              <img
                src="/markWatermark.png"
                // src="/tta_logo.jpg"
                alt="Watermark Logo"
                className="watermark-logo"
              />
            </div>
                <div className="d-flex justify-content-between align-items-center institute-header">
                  <div className="me-5">
                    <Image
                      src="/tta_logobg.png"
                      alt="Logo"
                    className="print-logo"
                      style={{ width: '90px', height: '90px' }}
                    />
                  </div>

                  <div className='institute-header-text' style={{color:"blue"}}>
                    <h2 className="fw-bold mb-2">{instituteName}</h2>
                    <h4 className="fw-bold">
                      {instituteAddress} - {institutePincode}
                    </h4>
                    <p className="powered" style={{ fontStyle: 'italic', fontSize: '14px', fontWeight:"600" }}>
                  Powered by <strong>Tera Tujko Arpan (ISO 9001 : 2015)</strong>
                </p>
                  </div>
                  
               <div className='text-center'>
                          <img 
                            src="/nct_logo2.png" 
                            alt="NCT Logo" 
                            className="img-nct"
                            style={{ width: '70px',height:'70px' }}
                          />
                           <div className='gvt' style={{ fontSize: '10px', fontWeight: 'bold', marginTop: '4px' }}>
                            GOVERNMENT OF NCT OF DELHI
                          </div>
                          </div>
                </div>
                {/* <div className='sub-header '>
                  <hr />
                  <h4 className="text fw-bold text-uppercase">
                    {data[0]?.course?.name}
                  </h4>
                  <h5 className=" fw-semibold  mt-0">Student Result</h5>
                  <p className="text-muted fw-semibold">Session : {data[0]?.exam?.session}</p>
                  <hr style={{ marginTop: '1rem' }} />
                </div> */}

               {/* <div className='sub-header'> */}

                <hr />
                <div className="sub-header d-flex align-items-center justify-content-between position-relative">
                  {/* <img
                    src="/nielit.png"
                    alt="Logo"
                    style={{ width: '100px', height: '100px',position: 'absolute', marginTop:"4rem" }}                    
                     className="nielit-logo"
                  /> */}
                  <h4 className="text fw-bold text-uppercase w-100 text-center m-0">
                    {data[0]?.course?.name}
                  </h4>
                </div>

                <h5 className="fw-semibold mt-0">Student Result</h5>
                <p className="text-muted fw-semibold">Session : {data[0]?.exam?.session}</p>
                <hr style={{ marginTop: '1rem' }} />
              {/* </div> */}

                <Row className="text-start align-items-center profile-print">
                  <Col xs={12} md={8}>
                    <Row>
                      <Col xs={12} md={6}>
                        <p>
                          <strong>Admission Number :{' '}
                          {data[0]?.student?.admission_number}</strong>
                        </p>
                       
                        <p>
                          <strong>Email : {data[0]?.student?.email}</strong>
                        </p>
                        <p>
                          <strong>Father's Name :{' '}
                          {data[0]?.student?.father_name}</strong>
                        </p>
                        
                        <p>
                          <strong>Phone : {data[0]?.student?.phone}</strong>
                        </p>
                      </Col>

                      <Col xs={12} md={6}>
                      <p>
                          <strong>NAME OF STUDENT :{' '}
                          {data[0]?.student?.name}</strong>
                        </p>
                        <p>
                          <strong>Date of Birth :{' '}
                          {data[0]?.student?.dob
                            ? new Date(data[0].student.dob).toLocaleDateString(
                                'en-GB',
                                {
                                  day: 'numeric',
                                  month: 'long',
                                  year: 'numeric',
                                },
                              )
                            : ''}</strong>
                        </p>
                        <p>
                          <strong>Mother's Name :{' '}
                          {data[0]?.student?.mother_name}</strong>
                        </p>
                        {/* <p>
                          <strong>Marksheet Number</strong> : {data[0]?.student?.marksheet_number || "N/A"}
                        </p> */}
                       
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={12} md={3} className="text-center mt-md-0">
                    <Image
                      src={img?.student_image  ? img?.student_image.replace(
                        BASE_URL_Upload + '/storage/student/',
                        BASE_URL_Upload + '/student/images/student/',
                      )
                    : '/studentprofile.jpg'}
                      // style={{ height: '170px', width: '170px' }}
                      // className="img-fluid  p-1 rounded-2"
                       style={{ width: '120px', height: '120px', objectFit: 'cover', border: '1px solid #333' }}
                       className="mt-2"
                      alt="Student"
                    />
                  </Col>
                </Row> 
                {/* <Row className="profile-print align-items-start mt-4">
  <Col xs={12} md={9}>
    <Row>
      <Col xs={12} md={6}>
        <p><strong>Admission Number</strong>: {data[0]?.student?.admission_number}</p>
        <p><strong>Email</strong>: {data[0]?.student?.email}</p>
        <p><strong>Father's Name</strong>: {data[0]?.student?.father_name}</p>
        <p><strong>Phone</strong>: {data[0]?.student?.phone}</p>
      </Col>
      <Col xs={12} md={6}>
        <p><strong>NAME OF STUDENT</strong>: {data[0]?.student?.name}</p>
        <p><strong>Date of Birth</strong>: {
          data[0]?.student?.dob
            ? new Date(data[0].student.dob).toLocaleDateString('en-GB', {
                day: 'numeric', month: 'long', year: 'numeric'
              })
            : ''
        }</p>
        <p><strong>Mother's Name</strong>: {data[0]?.student?.mother_name}</p>
      </Col>
    </Row>
  </Col>

  <Col xs={12} md={3} className="text-center">
    <Image
      src={data[0]?.student?.photo || "/user_avatar.png"}
      alt="Student"
      style={{ width: '120px', height: '140px', objectFit: 'cover', border: '1px solid #333' }}
      className="mt-2"
    />
  </Col>
</Row> */}

                <hr />
                <div className="mt-3">
                  <Table striped bordered hover className="text-center">
                    <thead className="table text-dark table-head-print" style={{
                      backgroundColor:"white"
                    }}>
                      <tr>
                        <th>S. No.</th>
                        <th>Subject</th>
                      
                       
                        {uniqueExams.map(([examId, examName ], i) => (
                        <th key={i} >
                       {examName} 
                       <Button
                        variant="link"  
                        style={{marginTop:"-6px"}}
                        onClick={() => handleEditMarksheet(examId)}
                        className="ms-5 p-0 btn btn-link link-danger text-decoration-none justify-content-end no-print"
 
                      >
                        [ <FaEdit size={14} /> Edit ]
                      </Button>
                    </th>
                  ))}
                        <th>Cumulative</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody className='table-body-print' style={{fontWeight:"bold"}}>
                  {processedSubjects.map((subject, index) => (
                    <tr key={index} 
                    // style={{backgroundColor:"#F3F8F6"}}
                    >
                      <td>{index + 1}</td>
                      <td>{subject.subjectName}</td>
                      {examNames.map((exam, i) => {
                        const totalMarks = examTotalMarksMap.get(exam); // total marks for that exam
                        const subjectExam = subject.exams[exam]; // marks for this subject in that exam

                        return (
                          <td key={i}>
                            {subjectExam ? (
                              <div>
                                <div className="small fw-bold">{subjectExam.marks} | {totalMarks}</div>
                              </div>
                            ) : (
                              '-'
                            )}
                          </td>
                        );
                      })}
                      <td>{Math.floor(subject.average)}</td>
                      <td className={subject.finalStatus === "Pass" ? "text-success" : "text-danger"}>
                        {subject.finalStatus}
                      </td>
                    </tr>
                  ))}
                  </tbody> 


                  </Table>
                </div>
                <div className="justify-content-between d-flex mt-5 table-footer-print">
                <p className="fw-bold">
                    Verified By_______________________________________________
                  </p>
                  <p className="fw-bold">
                    Authorized
                    Signature_______________________________________________
                  </p>
                </div>
                

              </Card>
          </div>
        </div>
      ) : (
        <p className="text-center mt-4 ">Please select the above fields</p>
      )}
       <div className="mt-5 w-100 no-print">
                <Card className="p-4 shadow-sm border-dark rounded-2">
                 

                  <Row className="mt-4 align-items-start">
                    <Col md={6}>
                      <Table bordered className="text-center">
                        <thead className="table-dark">
                          <tr>
                            <th>Marks Range</th>
                            <th>Grade</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>90 - 100</td>
                            <td>A+</td>
                          </tr>
                          <tr>
                            <td>80 - 89</td>
                            <td>A</td>
                          </tr>
                          <tr>
                            <td>70 - 79</td>
                            <td>B+</td>
                          </tr>
                          <tr>
                            <td>60 - 69</td>
                            <td>B</td>
                          </tr>
                          <tr>
                            <td>50 - 59</td>
                            <td>C</td>
                          </tr>
                          <tr>
                            <td>35 - 49</td>
                            <td>D</td>
                          </tr>
                          <tr>
                            <td>Below 35</td>
                            <td>F</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <Col md={6}>
                      <div className="d-flex justify-content-around text-center">
                        <div>
                          <p className="fw-semibold mb-1">Percentage</p>
                          <hr className="w-50 mx-auto mt-0 mb-2" />
                          <p className="text-success fw-bold"></p>
                        </div>

                        <div>
                          <p className="fw-semibold mb-1">Grade</p>
                          <hr className="w-50 mx-auto mt-0 mb-2" />
                          <p className="text-info fw-bold"></p>
                        </div>

                        <div>
                          <p className="fw-semibold mb-1">Division</p>
                          <hr className="w-50 mx-auto mt-0 mb-2" />
                          <p className="text-primary fw-bold"></p>
                        </div>
                      </div>
                      <div className="text-end mt-5">
                        <p className="fw-bold">
                          Authorized
                          Signature_______________________________________________
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Card>
        </div> 
    </div>
    </>
  )
}
